import { Alert, Box, CircularProgress, Modal, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PaperCustomized from "../../../common/components/PaperCustomized";
import ScrollToTop from "../../../common/components/ScrollToTop";
import StickyCustomized from "../../../common/components/StickyCustomized";
import { HOME_PAGE } from "../../../common/constants/routerConstants";
import { ExportTitres } from "../../../common/utils/FunctionsUtils";
import {
  getModeReglement,
  getTiApurement,
  getTiBanque,
  getTiCategories,
  getTiColumnsDensityState,
  getTiEtats,
  getTiLocalites,
  getTiStatusModif,
  getTiTypeMessage,
  getTypeReglement,
  searchTitres,
} from "../state/TiActions";
import ListTitres from "./ListTitres";
import SearchTitreForm from "./SearchTitreForm";

function GestionTitres(props) {
  const dispatch = useDispatch();
  const tiReducer = useSelector((state) => state.tiReducer);
  const navigate = useNavigate();
  const isLoading = tiReducer?.isTitresLoading;
  const error = tiReducer?.error;
  const errore = tiReducer?.errore;
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [severity, setSeverity] = useState("");
  const [firstAccess, setFirstAccess] = useState(true);
  const etats = tiReducer?.etats;
  const categories = tiReducer?.categories;
  const statusModif = tiReducer?.statusModif;
  const typeMessages = tiReducer?.typeMessages;
  const banques = tiReducer?.banques;
  const isDownloadLoading = tiReducer?.isDownloadLoading;

  const isLoadingSearch =
    !(categories && etats && statusModif && typeMessages && banques) ||
    tiReducer?.isEtatTableLoading;
  const isAllTitresLoading = useSelector(
    (state) => state.tiReducer.allTitresLoading
  );
  const [readyToExport, setReadyToExport] = useState(false);

  useEffect(() => {
    if (error !== null) {
      setAlertMessage("Une erreur s'est produite, merci de ressayer plus tard");
      setShouldNavigate(true);
      setAlertOpen(true);
      setSeverity("error");
    } else if (errore !== null) {
      setAlertMessage(errore);
      setAlertOpen(true);
      setSeverity("error");
    }
  }, [error, errore]);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    if (shouldNavigate === true) {
      navigate(HOME_PAGE);
    }
    setAlertOpen(false);
  };

  const [pagination, setPagination] = useState(
    tiReducer?.searchTitreObject?.pagination
  );

  const [searchObject, setSearchObject] = useState(
    tiReducer?.searchTitreObject
  );

  const allTitresLoading = useSelector(
    (state) => state.tiReducer.allTitresLoading
  );

  const [expandedAccordion, setExpandedAccordion] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 350, left: 0, behavior: "smooth" });
  }, [searchObject]);

  useEffect(() => {
    if (!allTitresLoading && readyToExport && tiReducer?.AllTitres?.content) {
      const allRows = tiReducer?.AllTitres?.content?.map((row) => row);
      ExportTitres(allRows);
      setReadyToExport(false);
    }
  }, [allTitresLoading, readyToExport, tiReducer?.AllTitres]);

  useEffect(() => {
    dispatch(getTiEtats());
    dispatch(getTiCategories());
    dispatch(getTiStatusModif());
    dispatch(getTiTypeMessage());
    dispatch(getTiBanque());
    dispatch(getTypeReglement());
    dispatch(getModeReglement());
    dispatch(getTiApurement());
    dispatch(getTiLocalites());
    dispatch(getTiColumnsDensityState());
  }, []);

  useEffect(() => {
    if (pagination !== searchObject.pagination) {
      setSearchObject((prevState) => ({
        ...prevState,
        pagination,
      }));
    }
    let tempSearchObject = {
      ...searchObject,
      pagination,
    };
    if (!firstAccess) {
      handleSearchData(tempSearchObject, expandedAccordion);
    } else {
      setFirstAccess(false);
    }
  }, [pagination]);

  useEffect(() => {
    setPagination(searchObject?.pagination);
  }, [dispatch, searchObject, expandedAccordion]);

  const handleSearchData = (data, expanded) => {
    setSearchObject(data);
    setExpandedAccordion(expanded);
    dispatch(searchTitres(data, expanded));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: "20px",
      }}
    >
      <Helmet>
        <title>{"Liste titres - Portail Banques"}</title>
      </Helmet>
      {isLoadingSearch ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
            mt: "20%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            gap: "20px",
          }}
        >
          <Modal
            open={isDownloadLoading}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            }}
          >
            <CircularProgress />
          </Modal>
          <StickyCustomized>
            <PaperCustomized forActions={true}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box></Box>
                <Box
                  sx={{
                    display: "",
                    justifyContent: "space-between",
                    height: 22,
                  }}
                />
              </Box>
            </PaperCustomized>
          </StickyCustomized>
          <Modal
            open={isAllTitresLoading}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            }}
          >
            <CircularProgress />
          </Modal>
          <Box sx={{ marginTop: "10px" }}>
            <PaperCustomized forActions={true} title="Paramètres de recherche">
              <SearchTitreForm
                searchObject={searchObject}
                setSearchObject={setSearchObject}
                onSearchData={(data, exp) => {
                  setFirstAccess(true);
                  handleSearchData(data, exp);
                }}
                paginat
                pagination={pagination}
                setPaginationModel={setPagination}
              />
            </PaperCustomized>
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            <ListTitres
              titres={tiReducer?.titres}
              paginationModel={pagination}
              setPaginationModel={setPagination}
              loading={isLoading}
            />
          </Box>
        </Box>
      )}
      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
      <ScrollToTop />
    </Box>
  );
}

export default GestionTitres;
